export const SURVEY_JS_ENDPOINT = "https://ppformbuilder.xantura.com/xantura-formbuilder/display";
export const BOT_SECRETKEY = "lbgEwl8jA54.umt09e0eLpHuxLQ5OFedOD8s5R5vvZV31zAjMxGk4wA";
